export interface SupportContext {
  sourcePath: string;
  projectId?: string;
  contractId?: string;
}

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const validId = (value: unknown): string | undefined => typeof value === 'string' && uuid.test(value) ? value : undefined;

// Keep only the path and known IDs. Query strings/hash may contain payment or
// invitation tokens and must never be copied wholesale into a support request.
export function supportContextFromLocation(
  location: { pathname: string; search: string },
  selected: { projectId?: string; contractId?: string } = {}
): SupportContext {
  const params = new URLSearchParams(location.search);
  const projectInPath = location.pathname.match(/^\/(?:person\/|company\/|admin\/|lawyer\/|inspector\/)?projects\/([^/]+)(?:\/|$)/)?.[1];
  return sanitizeSupportContext({
    sourcePath: location.pathname,
    projectId: selected.projectId ?? projectInPath ?? params.get('projectId'),
    contractId: selected.contractId ?? params.get('contractId')
  });
}

export function sanitizeSupportContext(value: unknown): SupportContext {
  const input = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  const sourcePath = typeof input.sourcePath === 'string' && input.sourcePath.length <= 500 && /^\/(?!\/)[a-zA-Z0-9/_-]*$/.test(input.sourcePath)
    ? input.sourcePath : '/kontakt';
  const projectId = validId(input.projectId);
  const contractId = validId(input.contractId);
  return { sourcePath, ...(projectId ? { projectId } : {}), ...(contractId ? { contractId } : {}) };
}
